{
    "notifications": {
        "Bildirimler": "Bildirimler",
        "Ara...": "Ara...",
        "Hata oluştu": "Hata oluştu",
        "Admin": "Admin",
        "Tümünü Okunmadı Olarak İşaretle": "Tümünü Okunmadı Olarak İşaretle",
        "Tümünü Okundu Olarak İşaretle": "Tümünü Okundu Olarak İşaretle",
        "Bildirim Bulunamadı!": "Bildirim Bulunamadı!",
        "Tüm Bildirimleri Gör": "Tüm Bildirimleri Gör",
        "Tüm Bildirimler": "Tüm Bildirimler",
        "Hiç bildiriminiz yok": "Hiç bildiriminiz yok.",
        "Bildirim Gönder": "Bildirim Gönder",
        "Yönlendirilecek URL (Opsiyonel)": "Yönlendirilecek URL (Opsiyonel)",
        "Mesaj": "Mesaj",
        "Hedef Kitle": "Hedef Kitle",
        "Herkese Gönder": "Herkese Gönder",
        "Belirli Kullanıcılara Gönder": "Belirli Kullanıcılara Gönder",
        "Kullanıcı Seçiniz": "Kullanıcı Seçiniz",
        "Başlık": "Başlık",
        "Gönder": "Gönder",
        "Okundu Olarak İşaretle": "Okundu Olarak İşaretle",
        "Sil": "Sil",
        "Validation": {
            "required": "Zorunlu alan"
        },
        "success": "Bildirim başarıyla gönderildi.",
        "Bildirim Ayarları": "Bildirim Ayarları",
        "Tarayıcınız bildirimleri desteklemiyor": "Tarayıcınız bildirimleri desteklemiyor.",
        "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Bildirim izni reddedildi. Tarayıcı ayarlarından izin verin.",
        "Kayıtlı Cihazlar": "Kayıtlı Cihazlar",
        "Yenile": "Yenile",
        "Cihaz Bilgisi": "Cihaz Bilgisi",
        "Kayıt Tarihi": "Kayıt Tarihi",
        "Son Erişim": "Son Erişim",
        "İşlem": "İşlem",
        "Bilinmeyen Cihaz": "Bilinmeyen Cihaz",
        "Bu Cihaz": "Bu Cihaz",
        "Kayıtlı cihaz bulunamadı": "Kayıtlı cihaz bulunamadı.",
        "Ayarlar": "Ayarlar",
        "Cihaz listesi alınamadı": "Cihaz listesi alınamadı.",
        "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz?",
        "Cihaz silindi": "Cihaz silindi.",
        "Cihaz silinemedi": "Cihaz silinemedi.",
        "Bildirimleri Kapat": "Bildirimleri Kapat",
        "Bildirimleri Aç": "Bildirimleri Aç",
        "Bildirim İzinleri": "Bildirim İzinleri",
        "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz": "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz."
    }
}
